import React from "react";

// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonStepper from "../Common/CommonStepper";
import {retrieveModelField} from "../../utils/misc";
import {retrieveEntity} from "../Common/utils";

// icons
import {CircularProgress,} from "@mui/joy";


class DeliveryControlledEntityCreateInner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            entityType: null,
            urls: null
        }
        this.steps = [
            {
                order: 0,
                title: 'Сущность',
            },
            {
                order: 1,
                title: 'Экземпляр',
            },
        ]
    }

    async retrieveEntityType() {
        const url = `common/entity_types`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        return [
            response.data.entity_types,
            response.data.urls
        ]
    }

    async componentDidMount() {
        let [entityTypes, urls] = await this.retrieveEntityType()
        let formFields = [
            {
                name: 'entityType',
                label: 'Тип',
                xs: 12,
                sm: null,
                md: null,
                lg: null,
                xl: null,
                required: true,
                default: this.state.entityType?this.state.entityType:null,
                type: 'select',
                options: entityTypes.map(
                    (a) => ({
                        value: a[0],
                        label: a[1],
                    })
                )
            },
            {
                type: 'submit',
                label: 'Далее',
            },
        ]
        this.setState(
            {
                urls: urls,
                formFields: formFields,
            }
        );
    }

    async retrieveEntity(){
        this.setState({
            formFields: null
        })
        let entityType = this.state.entityType
        if (entityType) {
            let field = await retrieveModelField(
                this.state.urls[entityType],
                {
                    opportunity: this.props.delivery.opportunity.id
                },
                'entityId',
                '',
                'id',
                ['system_title'],
                false,
                null,
                true
            )
            let motherEntity = await retrieveEntity(
                'opportunity',
                this.props.delivery.opportunity.id
            )
            if (motherEntity) {
                for (let key of Object.keys(motherEntity)) {
                    if (typeof motherEntity[key] === 'object') {
                        if (key === entityType.toLowerCase()) {
                            field.options.push(
                                {
                                    value: motherEntity.id,
                                    label: motherEntity[key].system_title?motherEntity[key].system_title:`${this.state.entityType} - ${motherEntity[key].id}`,
                                }
                            )
                        }
                    }
                }
            }

            this.setState(
                {
                    formFields: [
                        field,
                        {
                            type: 'submit',
                            label: 'Добавить',
                        },
                    ],
                    activeStep: 1,
                }
            );
        }
    }

    async processStep0(form) {
        let entityType = form.state.formData.get('entityType');
        this.setState({
            entityType: entityType,
        }, this.retrieveEntity)
    }

    async processStep1(form) {
        let entityId = form.state.formData.get('entityId');
        const url = 'delivery_controlled_entity/';
        const api = new BaseApi();
        let response = await api.post(
            url,
            {
                entity: this.state.entityType,
                entity_id: entityId,
                delivery: this.props.delivery.id
            }
        );
        if (response.status === 201) {
            if (this.props.callBack){
                await this.props.callBack()
            }
        }
    }

    async setStep(order) {
        let formData = new FormData();
        let formFake = {'state': {'formData': formData}}
        if (order === 0){
            await this.componentDidMount()
        }
        else {
            await this['processStep'+(order-1)](formFake)
        }
        this.setState(
            {activeStep: order}
        )
    }

    render() {
        if (!this.state.formFields) {
            return (<CircularProgress />)
        }
        if (this.state.activeStep === 0) {
            return (
                <>
                    <CommonStepper
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                    />
                    <CommonForm
                        fields={this.state.formFields}
                        processForm={this.processStep0.bind(this)}
                    />
                </>
            )
        }
        else if (this.state.activeStep === 1) {
            return (
                <>
                    <CommonStepper
                        steps={this.steps}
                        activeStep={this.state.activeStep}
                        callBack={this.setStep.bind(this)}
                    />
                    <CommonForm
                        fields={this.state.formFields}
                        processForm={this.processStep1.bind(this)}
                    />
                </>
            )
        }
    }
}

export default DeliveryControlledEntityCreateInner
